import { TLCLogger } from "../../../js/lib/logger";

export class GoogleAnalyticsTracker {

	initialized = false;

	constructor(code, enabled, variables, customMap) {
		if (code === null || code === undefined) {
			throw new Error("Required GA properties missing");
		}

		this.trackingCode = code;
		this.enabled = enabled || false;
		this.customVariables = variables || [];
		this.customMap = customMap;
		this.hitDimensions = {};

		if (this.enabled) {
			this.init();
		}
	}
	gtag() {
		window.dataLayer.push(arguments);
	}
	init() {
		TLCLogger.log("GoogleAnalyticsTracker.init");
		try {
			this.initialized = true;

			var cfgObj = $.extend(this.customVariables, { 'custom_map': this.customMap });
			this.gtag('config', this.trackingCode, cfgObj);

			TLCLogger.log("GoogleAnalyticsTracker.init done");
		} catch (error) {
			TLCLogger.log("Error", error);
		}
	}
	trackPageView(pageView, debugMessage) {
		if (this.enabled) {
			if (!this.initialized) {
				this.init();
			}
			try {
				var prefix = "/ls2pac/";

				var googleAnalyticsOptions = {
					'send_to': this.trackingCode,
					'page_path': prefix + pageView
				};
				var mergedObj = $.extend(googleAnalyticsOptions, this.hitDimensions);
				this.gtag('event', 'page_view', mergedObj);

				this.logTracking(this.trackingCode + '.send', prefix + pageView, debugMessage);
			} catch (error) {
				TLCLogger.log("Error", error);
			}
		} else {
			TLCLogger.log("Google Analytics Disabled: TrackPageView - " + pageView);
		}
	}
	trackEvent(event, debugMessage) {
		if (this.enabled) {
			if (!this.initialized) {
				this.init();
			}
			try {
				var googleAnalyticsOptions = {
					'send_to': this.trackingCode,
					'event_category': event.categories
				};

				if (event.labels) {
					googleAnalyticsOptions['event_label'] = event.labels;
				}
				if (event.values) {
					googleAnalyticsOptions['value'] = event.values;
				}

				var mergedObj = $.extend(googleAnalyticsOptions, this.hitDimensions);
				this.gtag('event', event.actions, mergedObj);

				this.logTracking(this.trackingCode + '_trackEvent', event, debugMessage);
			} catch (error) {
				TLCLogger.log("Error", error);
			}
		} else {
			TLCLogger.log("Google Analytics Disabled: TrackEvent - " + event);
		}
	}
	logTracking(command, itemToTrack, debugMessage) {
		TLCLogger.log("Google Analytics:" + command);
		TLCLogger.log(itemToTrack);
		if (debugMessage) {
			TLCLogger.log(debugMessage);
		}
	}
	setHitDimension(key, value) {
		TLCLogger.log("Google Analytics: " + key + " - " + value);
		if (value === null && this.hitDimensions[key] !== undefined) {
			delete this.hitDimensions[key];
			return;
		}
		this.hitDimensions[key] = value;
	}
}

